/* (c) Copyright Frontify Ltd., all rights reserved. */

export const ROOT_ID = '__ROOT__';
export const INDENTATION_WIDTH = 20;
export const EXPAND_ONHOVER_DELAY = 350; // ms
